const o = (r) => Array.from({
  length: r
}, (e, n) => n);
export {
  o as n
};
